import { ECurrency } from "../types/currency.types";

export const currenciesSymbols = {
  [ECurrency.BYN]: "BYN",
  [ECurrency.USD]: "$",
  [ECurrency.EUR]: "€",
  [ECurrency.RUB]: "₽",
  [ECurrency.KZT]: "₸",
  [ECurrency.YUNIT]: "YUNIT",
  [ECurrency.YUN]: "¥",
};
